<template>
    <section class="col s12">
        <div class="row">
            <div class="col s12">
                <p>
                    Sua ação atua em territórios e/ou junto aos grupos vulneráveis?
                </p>

                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="acao_atgv"
                               class="with-gap"
                               type="radio"
                               id="rdSimAcaoAtgv"
                               :disabled="allDisabled"
                               :value="true"
                               v-model="acaoAtgv" />
                        <span>Sim</span>
                    </label>
                </div>
                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="acao_atgv"

                               class="with-gap"
                               type="radio"
                               id="rdNaoAcaoAtgv"
                               :disabled="allDisabled"
                               :value="false"
                               v-model="acaoAtgv" />
                        <span>Não</span>
                    </label>
                </div>
            </div>
        </div>

        <div class="row" v-if="acaoAtgv">
            <section class="animate__animated animate__fadeInDown">
                <div class="col s12">
                    <p><b>Selecione em quais grupos e/ou territórios a ação irá atuar:</b></p>
                </div>

                <div class="col s12">
                    <p v-for="(atuacao, atuacao_i) in atuacoesConfiguradas" :key="atuacao_i">
                        <label>
                            <input type="checkbox" class="filled-in"
                                   :name="`atuacoes_selecionadas[${atuacao.id}]`"
                                   :value="atuacao.id"
                                   :disabled="allDisabled"
                                   :checked="atuacaoJaFoiSelecionada(atuacao.id)"
                                   @click="marcaOuDesmarcaAtuacao(atuacao.id)" />
                            <span>{{ atuacao.nome }}</span>
                        </label>
                    </p>
                </div>
            </section>
        </div>

        <Resultado_avaliacoes_itens_acao v-if="avaliacoes"
                                         :avaliacoes="avaliacoes"
                                         campo-referente-na-inscricao="acao_atgv"></Resultado_avaliacoes_itens_acao>
    </section>
</template>

<script>
import 'animate.css';
import Resultado_avaliacoes_itens_acao from "./avaliacoes_resultado/resultado_avaliacoes_itens_acao";

export default {
    name: "inscricao_atuacoes",
    components: {Resultado_avaliacoes_itens_acao},
    props: {
        pAcaoAtgv: {
            type: Boolean,
            default: false,
        },
        pAtuacoesSelecionadas: {
            type: Array,
            default: () => { return [] },
        },
        pAtuacoesConfiguradas: {
            type: Array,
            default: () => { return [] },
        },
        allDisabled: {
            type: Boolean,
            default: false,
        },
        pAvaliacoes: {
            type: Array|null,
            default: null,
        }
    },
    data() {
        return {
            acaoAtgv: this.pAcaoAtgv,
            atuacoesSelecionadas: this.pAtuacoesSelecionadas,
            atuacoesConfiguradas: this.pAtuacoesConfiguradas,
            avaliacoes: this.pAvaliacoes,
        }
    },
    watch: {
        pAcaoAtgv(newValue) {
            this.acaoAtgv = newValue
        },
        acaoAtgv(newValue) {
            if(!newValue)
                this.removeTodasAsAtuacoesSelecionadas()

            this.$emit('update:pAcaoAtgv', newValue)
        },
        pAtuacoesSelecionadas: {
            deep: true,
            handler(newValue){
                this.atuacoesSelecionadas = newValue
            }
        },
        atuacoesSelecionadas: {
            deep: true,
            handler(newValue){
                this.$emit('update:pAtuacoesSelecionadas', newValue)
            }
        },
    },
    methods: {
        marcaOuDesmarcaAtuacao(id) {
            const indiceNaListaSelecionada = this.indiceNaListaDeSelecaoDaAtuacao(id)

            if(indiceNaListaSelecionada === -1)
                this.atuacoesSelecionadas.push({id: id})
            else
                this.atuacoesSelecionadas.splice(indiceNaListaSelecionada, 1)
        },
        indiceNaListaDeSelecaoDaAtuacao(id){
            return _.findIndex(this.atuacoesSelecionadas, (atuacao) => { return atuacao.id === id });
        },
        atuacaoJaFoiSelecionada(id){
            return this.indiceNaListaDeSelecaoDaAtuacao(id) !== -1
        },
        removeTodasAsAtuacoesSelecionadas(){
            this.atuacoesSelecionadas.splice(0)
        }
    },
}
</script>

<style scoped>

</style>
